import React from 'react';
import { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Container } from './styles/Container.styled';
import { SectionCareers, ArticleCareers, ArticleImage, ArticleText } from './styles/CareersBlock';

export default function Testimonial({ data, dir, id }) {
  const {
    testimonialTitle,
    testimonialText,
    testimonialPersonName,
    testimonialPersonTitle,
    testimonialPersonPicture,
  } = data;
  return (
    <SectionCareers id={id}>
      <Container>
        <ArticleCareers>
          <ArticleImage>
            {isEmpty(testimonialPersonPicture) || (
              <LazyLoadImage
                src={testimonialPersonPicture.url}
                placeholderSrc={
                  testimonialPersonPicture
                    ? `${testimonialPersonPicture.url}?width=50&quality=50`
                    : null
                }
                effect="blur"
              />
            )}
          </ArticleImage>
          <ArticleText dir={dir}>
            <h3 dir={dir}>{testimonialTitle}</h3>
            <p>{testimonialText}</p>
            <p className="tname">
              <span>{testimonialPersonName}</span>, {testimonialPersonTitle}
            </p>
          </ArticleText>
        </ArticleCareers>
      </Container>
    </SectionCareers>
  );
}
